import { PILL_LIMIT } from '../searchConstants';
import { getStore } from '../store/store';
export default function getCanAddMoreSuggestionPills() {
    return getStore().suggestionPillIds.length < PILL_LIMIT;
}
//# sourceMappingURL=getCanAddMoreSuggestionPills.js.map